module.exports = __webpack_public_path__ + "img/adulto24.8b10fbb7.jpg";